<div class="contact-section-wrap" [ngClass]="{
    tablet: globalUtilsService.isTablet(),
    mobile: globalUtilsService.isMobile()
  }">

  <div *ngIf="globalUtilsService.isDesktop()" class="contact-desktop">
    <app-contact-desktop></app-contact-desktop>
  </div>

  <div *ngIf="globalUtilsService.isTablet()" class="contact-tablet">
    <app-contact-tablet></app-contact-tablet>
  </div>

  <!-- <div class="contact-info-content" *ngIf="!globalUtilsService.isDesktop()">
    <app-contact-info></app-contact-info>
    <div class="info-block" *ngIf="globalUtilsService.isTablet()">
      <h2>Onde estamos</h2>
      <app-info-item class="info-item" icon="localization" label="TIBAU DO SUL | RN"
        link="https://bit.ly/37WsIf4"></app-info-item>
      <app-info-item icon="phone" class="info-item" label="(84) 93300.5548"
        link="https://api.whatsapp.com/send?phone=5584933005548&text=Ol%C3%A1%2C%20bem-vindo(a)%20%C3%A0%20Para%C3%ADso%20Fotovoltaico!%20Fale%20comigo%20por%20aqui..."></app-info-item>
      <app-info-item class="info-item" icon="instagram" label="SIGA-NOS"
        link="https://www.instagram.com/paraisofotovoltaico/"></app-info-item>
    </div>
  </div> -->

  <!--
  <div class="contact-content">
    <app-contact-info *ngIf="globalUtilsService.isDesktop()"></app-contact-info>
    <app-contact-form></app-contact-form>
  </div>

  <app-bottom-copyright
    style="grid-area: bottom; margin-top: 0.8rem;"
    *ngIf="globalUtilsService.isTablet()"
  ></app-bottom-copyright> -->
</div>
